import script from "./UserSettingPage.vue?vue&type=script&setup=true&lang=js"
export * from "./UserSettingPage.vue?vue&type=script&setup=true&lang=js"

import "./UserSettingPage.vue?vue&type=style&index=0&id=497d42b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-497d42b2"]])

export default __exports__